const API_URL = import.meta.env.VITE_API_URL || 'https://verbum-api-production.up.railway.app/api';

class BookmarkService {
  async parseErrorMessage(response, fallback) {
    try {
      const data = await response.json();
      if (typeof data?.error === 'string' && data.error.trim()) return data.error;
      if (typeof data?.detail === 'string' && data.detail.trim()) return data.detail;
      if (typeof data?.title === 'string' && data.title.trim()) return data.title;
    } catch {
      // no-op: non-json response body
    }
    return fallback;
  }

  // Получить все закладки
  async getBookmarks() {
    try {
      const authToken = localStorage.getItem('authToken');
      if (!authToken) {
        console.warn('No auth token found');
        return [];
      }

      const response = await fetch(`${API_URL}/bookmarks`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${authToken}`
        }
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('authToken');
          window.location.href = '/';
          throw new Error('Authentication failed. Please login again.');
        }
        const message = await this.parseErrorMessage(response, `HTTP ${response.status}`);
        console.error('Get bookmarks failed:', response.status, message);
        throw new Error(message);
      }

      const data = await response.json();
      console.log('Bookmarks loaded:', data.length);
      return data;
    } catch (error) {
      console.error('Get bookmarks error:', error);
      throw error;
    }
  }

  // Добавить закладку
  async addBookmark(bookId, chapter, verse, note = null) {
    try {
      const authToken = localStorage.getItem('authToken');
      if (!authToken) {
        throw new Error('Not authenticated');
      }

      const response = await fetch(`${API_URL}/bookmarks`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authToken}`
        },
        body: JSON.stringify({
          bookId: parseInt(bookId),
          chapter: chapter ? parseInt(chapter) : null,
          verse: verse ? parseInt(verse) : null,
          note: note || null
        })
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('authToken');
          window.location.href = '/';
          throw new Error('Authentication failed. Please login again.');
        }
        const message = await this.parseErrorMessage(response, 'Failed to add bookmark');
        throw new Error(message);
      }

      return await response.json();
    } catch (error) {
      console.error('Add bookmark error:', error);
      throw error;
    }
  }

  // Удалить закладку
  async deleteBookmark(bookmarkId) {
    try {
      const authToken = localStorage.getItem('authToken');
      if (!authToken) {
        throw new Error('Not authenticated');
      }

      const response = await fetch(`${API_URL}/bookmarks/${bookmarkId}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${authToken}`
        }
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('authToken');
          window.location.href = '/';
          throw new Error('Authentication failed. Please login again.');
        }
        const message = await this.parseErrorMessage(response, 'Failed to delete bookmark');
        throw new Error(message);
      }

      return await response.json();
    } catch (error) {
      console.error('Delete bookmark error:', error);
      throw error;
    }
  }


  // Обновить закладку
  async updateBookmark(bookmarkId, bookId, chapter, verse, note = null) {
    try {
      const authToken = localStorage.getItem('authToken');
      if (!authToken) {
        throw new Error('Not authenticated');
      }

      const response = await fetch(`${API_URL}/bookmarks/${bookmarkId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authToken}`
        },
        body: JSON.stringify({
          bookId: parseInt(bookId),
          chapter: chapter ? parseInt(chapter) : null,
          verse: verse ? parseInt(verse) : null,
          note: note || null
        })
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('authToken');
          window.location.href = '/';
          throw new Error('Authentication failed. Please login again.');
        }
        const message = await this.parseErrorMessage(response, 'Failed to update bookmark');
        throw new Error(message);
      }

      return await response.json();
    } catch (error) {
      console.error('Update bookmark error:', error);
      throw error;
    }
  }
}

export const bookmarkService = new BookmarkService();

